import { createContext } from "react";

// SSR ke dauraan fetch kiya gaya data yaha se pages ko milega,
// taaki client par dubara fetch na ho aur meta tags turant sahi dikhein
export const InitialDataContext = createContext(null);